export default __webpack_public_path__ + "static/media/plus-icon.ea7bc0e7.svg";